/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fast_Ivory_Trout_PlayInputs */

const en_fast_ivory_trout_play = /** @type {(inputs: Fast_Ivory_Trout_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const de_fast_ivory_trout_play = /** @type {(inputs: Fast_Ivory_Trout_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Fast_Ivory_Trout_PlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fast_ivory_trout_play = /** @type {((inputs?: Fast_Ivory_Trout_PlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fast_Ivory_Trout_PlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fast_ivory_trout_play(inputs)
	return de_fast_ivory_trout_play(inputs)
});